import request from '@/utils/request'

// 银行列表
export function bankNameList(data) {
  return request({
    url: 'api/v2/bank/bankNameList',
    method: 'post',
    data
  })
}

// 新增修改银行
export function saveBankName(data) {
  return request({
    url: 'api/v2/bank/saveBankName',
    method: 'post',
    data
  })
}

// 删除银行账户
export function bankNameDel(data) {
  return request({
    url: 'api/v2/bank/bankNameDel',
    method: 'post',
    data
  })
}


// 资金 - 银行
// 批量新增银行记录
export function saveBank(data) {
  return request({
    url: 'api/v2/bank/saveBank',
    method: 'post',
    data
  })
}

// 银行记录
export function bankList(data) {
  return request({
    url: 'api/v2/bank/bankList',
    method: 'post',
    data
  })
}

// 删除银行记录
export function delBank(data) {
  return request({
    url: 'api/v2/bank/delBank',
    method: 'post',
    data
  })
}